import React from "react";
import { FaInfoCircle } from "react-icons/fa"; // Info icon
import { MdClose } from "react-icons/md"; // Close icon
import styles from "./css/Info.module.css";

const LiquiditySweepInfo = ({ isOpen, toggleDrawer }) => {
  return (
    <div>
      {/* Collapsible Side Drawer */}
      <div className={`${styles.drawer} ${isOpen ? styles.open : ""}`}>
        <div className={styles.drawerHeader}>
          <MdClose className={styles.closeIcon} onClick={toggleDrawer} />
        </div>

        <div className={styles.infoItem}>
          <h4>What is a Liquidity Sweep?</h4>
          <p>
            A Liquidity Sweep occurs when price temporarily moves to a key level, such as a previous high, low, or support/resistance
            zone, to "sweep" liquidity in the form of stop-loss orders or pending orders. This sweep is typically followed by a sharp
            reversal or continuation in the opposite direction.
          </p>
          <p>
            <b>Why is it important to traders?</b> Liquidity sweeps are essential for understanding market manipulation and smart money
            strategies. They provide insight into:
          </p>
          <ul>
            <li>Where stop-loss orders are likely to be triggered.</li>
            <li>Potential points of price reversals or continuations.</li>
            <li>Identifying areas of institutional activity.</li>
          </ul>
        </div>

        <div className={styles.infoItem}>
          <h4>1. Liquidity Zones</h4>
          <p>
            <b>Definition:</b> Zones where a large number of orders are placed, such as at previous highs, lows, or consolidation
            levels.<br />
            <b>Usage:</b> Traders identify these zones to anticipate potential sweeps and market reactions.
          </p>
        </div>

        <div className={styles.infoItem}>
          <h4>2. Stop-Loss Clusters</h4>
          <p>
            <b>Definition:</b> Areas where stop-loss orders are concentrated, typically just above resistance levels or below support
            levels.<br />
            <b>Usage:</b> Market makers or institutional traders often target these clusters to generate liquidity for large orders.
          </p>
        </div>

        <div className={styles.infoItem}>
          <h4>3. Sweep Execution</h4>
          <p>
            <b>Definition:</b> A temporary spike in price that triggers stop-loss orders and activates pending orders.<br />
            <b>Usage:</b> This often creates a false breakout, providing an opportunity for traders to enter in the direction of the
            true trend after the sweep.
          </p>
        </div>

        <div className={styles.infoItem}>
          <h4>4. Post-Sweep Reversal</h4>
          <p>
            <b>Definition:</b> A sharp reversal in price after the liquidity sweep, indicating that the market is resuming its intended
            direction.<br />
            <b>Usage:</b> Traders look for price action confirmation (e.g., engulfing candles, pin bars) to enter trades after a sweep.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LiquiditySweepInfo;
